export default __webpack_public_path__ + "static/media/Cross.7681af78.svg";